import Tablesort from "./tablesort.min";
globalThis.Tablesort = Tablesort;
